import { action as apiAction } from 'api/Api'

type Payload = {
  cardId: number
  template: any
}

export default (payload: Payload) => async () => {
  const { cardId, template } = payload

  await apiAction('ApplyCardTemplate', {
    cardId,
    template
  })
}
